import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStoreActions } from 'easy-peasy';
import { selectorRootActions } from '@model/index';
import {
  ACTION_VARIANTS,
  Button,
  Dropdown,
  ICON_NAMES,
  useClickOutside,
} from '@reverse-hr/design-system';

const LanguageSwitcher = () => {
  const { t, i18n } = useTranslation();
  const { changeLanguage } = useStoreActions(selectorRootActions);
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  const languages = Object.keys(i18n.options?.resources ?? {});

  useClickOutside({
    elementRef: wrapperRef,
    handler: () => setIsOpen(false),
  });

  const onToggleClick = () => setIsOpen(!isOpen);

  const onLanguageClick = language => {
    setIsOpen(false);

    if (language === i18n.language) {
      return;
    }

    changeLanguage(language);
  };

  return (
    <div className="c-language-switcher" ref={wrapperRef}>
      <Button
        className="c-language-switcher__toggle"
        onClick={onToggleClick}
        rightIcon={ICON_NAMES.CHEVRON_BIG_DOWN}
        variant={ACTION_VARIANTS.GHOST}
      >
        {t(`language_switcher.${i18n.language}`)}
      </Button>

      <Dropdown isOnRight isOpen={isOpen}>
        <Dropdown.List>
          {languages.map(language => (
            <Dropdown.Item
              headline={t(`language_switcher.${language}`)}
              isSelected={language === i18n.language}
              key={language}
              onClick={() => onLanguageClick(language)}
            />
          ))}
        </Dropdown.List>
      </Dropdown>
    </div>
  );
};

export default LanguageSwitcher;
